















































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class App extends Vue {
  private drawer = false;
  private showFilters = false;
  private hasFilters = false;

  @State('isAuthenticating')
  private loading!: boolean;

  private created() {
    this.showFilters = !!this.$store.getters.listFilter.supplyManager;
  }

  public async logout() {
    this.$store.dispatch('LOGOUT');
    this.drawer = !this.drawer;
  }

  public jobs() {
    this.drawer = !this.drawer;
    this.$router.push({ name: 'List' });
  }

  get view() {
    this.hasFilters = this.$route.name === 'List';

    if (this.$route.name === 'Details') {
      const job = this.$store.getters['api/order/job/job'];

      return job && job.orderId ? `Order ${job.orderId}` : 'Order details';
    }

    return this.$route.name;
  }
}
